// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import NotificationItem from '../../common/ui/notification-item';
import NotificationItemSkeleton from '../../common/ui/notification-item-skeleton';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledNotificationItem = styled(NotificationItem)({
  marginBottom: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var StyledNotificationItemSkeleton = styled(NotificationItemSkeleton)({
  marginBottom: "var(--ds-space-100, 8px)"
});